export default {"src":"/_next/static/media/eye-active.03dc4f88.svg","height":24,"width":24};